import React from 'react';
import { PdfViewer } from './PdfViewer';

export type PdfPresenterExtendProps = {
	title?: string;
	src?: string;
	externalSrc?: string;
};

export type PdfPresenterProps = {
	title?: string;
	srcSet: {
		primary?: string;
		secondary?: string;
	};
};

export const PdfPresenter = ({ srcSet, ...props }: PdfPresenterProps) => {
	// PDF.js uses the proxy because the application's CSP blocks fetches to Google Storage.
	// The direct signed URL remains available only for opening the file in a new tab.
	const viewerSrc = srcSet?.secondary || srcSet?.primary;
	const externalSrc = srcSet?.primary !== viewerSrc ? srcSet?.primary : undefined;

	return (
		<div
			className="flex flex-column w-full h-full gap-2 p-2 bg-gray-100 overflow-scroll"
			style={{ minHeight: 500 }}
		>
			<PdfViewer {...props} src={viewerSrc} externalSrc={externalSrc} />
		</div>
	);
};
